import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';
import { canAccessLegalizacao } from './legalizacaoAccess';

export const isInternalAdminEmail = canAccessLegalizacao;

export function AdminInternalRoute({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated } = useAdminAuth();

  if (!isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  if (!canAccessLegalizacao(user?.email)) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}
